const HELP_BASE_HOST = 'help.enlil.io';
const CONTACT_PORTAL_URL = 'https://shifamed.atlassian.net/servicedesk/customer/portals';
const NON_ENV_SUBDOMAINS = new Set(['app', 'help', 'main', 'www']);

export interface HelpCenterFooterLinks {
  releaseNotes: string;
  contact: string;
}

export const DEFAULT_HELP_CENTER_FOOTER_LINKS: HelpCenterFooterLinks = {
  releaseNotes: `https://${HELP_BASE_HOST}/release_notes.html`,
  contact: CONTACT_PORTAL_URL,
};

function getEnvironmentSegment(hostname: string): string | null {
  if (!hostname.endsWith('enlil.io')) {
    return null;
  }

  const parts = hostname.split('.');
  if (parts.length < 3) {
    return null;
  }

  const envSegment = parts.at(-3);
  if (!envSegment || NON_ENV_SUBDOMAINS.has(envSegment)) {
    return null;
  }

  return envSegment;
}

function resolveHelpBaseUrl(hostname: string | null | undefined): string {
  const envSegment = hostname ? getEnvironmentSegment(hostname) : null;
  return envSegment
    ? `https://help.${envSegment}.enlil.io`
    : `https://${HELP_BASE_HOST}`;
}

export function resolveHelpCenterFooterLinks(hostname?: string | null): HelpCenterFooterLinks {
  const helpBaseUrl = resolveHelpBaseUrl(hostname);

  return {
    releaseNotes: `${helpBaseUrl}/release_notes.html`,
    contact: CONTACT_PORTAL_URL,
  };
}
